export default __webpack_public_path__ + "public/assets/images/0a73de91d3d8ed022ddc6c7bfa7abab3.png";